/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UserRestService } from '@gh/builder-shared-data';
import { InitDialogViewService, UserContext } from '@gh/common-shared';
import { DialogRouteSnapshot, S3UploadItem } from '@gh/core-ui';
import { Observable } from 'rxjs';

export type UserProfileSignature = { picture: S3UploadItem };

export type UserProfileSignatureDialogConfig = Record<string, never>;

@Injectable()
export class UserProfileSignatureBusinessService implements InitDialogViewService<UserProfileSignatureDialogConfig> {
  constructor(
    private userContext: UserContext,
    private userRest: UserRestService,
  ) {
  }

  initDialogView(route: DialogRouteSnapshot<UserProfileSignatureDialogConfig>): any {
    return {
      signature: this.getSignature(),
    };
  }

  getSignature(): Observable<S3UploadItem> {
    return this.userRest.getSignature(this.userContext.data.id);
  }

  createSignature(signature: S3UploadItem): Observable<S3UploadItem> {
    return this.userRest.createSignature(this.userContext.data.id, signature);
  }
}
